document.addEventListener('DOMContentLoaded', () => {
    const filterHeader = document.querySelector('.article-filter__header')
    const filterForm = document.querySelector('.article-filter-container')

    if (!filterHeader) return

    const filterTitle = filterHeader.querySelector('.article-filter__title')
    const filterClose = filterHeader.querySelector('.article-filter__close')

    if (filterTitle && filterClose && filterForm) {
        const BREAKPOINT = 992

        const isDesktop = () => window.innerWidth >= BREAKPOINT

        const openFilter = () => {
            filterForm.classList.add('is-open')
            filterHeader.classList.add('is-open')
            document.body.style.overflow = 'hidden'
        }
        const closeFilter = () => {
            filterForm.classList.remove('is-open')
            filterHeader.classList.remove('is-open')
            document.body.style.overflow = ''
        }

        filterTitle.addEventListener('click', () => {
            if (!isDesktop()) openFilter()
        })

        filterClose.addEventListener('click', () => {
            closeFilter()
        })

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !isDesktop()) closeFilter()
        })

        const navbarToggler = document.querySelector('.navbar-toggler')
        if (navbarToggler) {
            navbarToggler.addEventListener('click', () => {
                closeFilter()
            })
        }

        const today = new Date().toISOString().split('T')[0]
    const dateFromInput = document.getElementById('filter-date-from')
    const dateToInput = document.getElementById('filter-date-to')
    if (dateFromInput) dateFromInput.max = today
    if (dateToInput) dateToInput.max = today

    const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('filter_open') && !isDesktop()) {
            openFilter()
            urlParams.delete('filter_open')
            const cleanUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '')
            history.replaceState(null, '', cleanUrl)
        }
    }

    const filterIconImg = filterHeader.querySelector('.article-filter__title img')
    if (filterIconImg && filterForm) {
        const iconDefault = filterIconImg.src
        const iconActive = iconDefault.replace(/filter(\.svg)$/, 'filter-used$1')

        const hasActive = () => {
            const params = new URLSearchParams(window.location.search)
            for (const [key, value] of params) {
                if (key.startsWith('filter_') && key !== 'filter_open' && value) return true
            }
            return false
        }

        filterIconImg.src = hasActive() ? iconActive : iconDefault
    }
})
